import { render } from "./dialog_modal.vue?vue&type=template&id=53f4dfbe"
import script from "./dialog_modal.js?vue&type=script&lang=js"
export * from "./dialog_modal.js?vue&type=script&lang=js"

import "./dialog_modal.vue?vue&type=style&index=0&id=53f4dfbe&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__